module.exports = __webpack_public_path__ + "static/img/1-2.85b5c87.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/1-2.png
// module id = Czyg
// module chunks = 0